import React from "react";
import { SectionHeader } from "@/components/design-system/SectionHeader/SectionHeader";
import { WealthEllipseGlow } from "./icons/WealthEllipseGlow";
export const AdvisorIntelligenceSection: React.FC = () => (
  <section className="relative w-full overflow-hidden bg-white">
    <WealthEllipseGlow className="pointer-events-none absolute" style={{ top: "205px", left: "156px", width: "1118px", height: "663px", zIndex: 0 }} />

    <div className="relative z-10 mx-auto max-w-360 px-5 pt-16 pb-8 md:px-8 md:pt-24 md:pb-10 lg:px-16">
      <SectionHeader
        label="Advisor Intelligence"
        heading={<>Every advisor.{" "}<span className="text-primary-500">Fully prepared.</span></>}
        description="Before every meeting, Bravo generates a structured intelligence brief — giving your advisors the full participant picture, flagged opportunities, and suggested talking points before they pick up the phone."
      />

      <div className="mx-auto xl:max-w-282">
        <div className="flex items-start justify-center">
          <img
            src="/wm-talking-points-card.png"
            alt="Talking Points"
            className="relative z-20 mt-15.5 h-32 w-auto shrink-0 md:mt-41 md:h-69.5"
          />
          <img
            src="/wm-advisor-brief-card.png"
            alt="Advisor Intelligence Brief"
            className="relative z-10 h-52 w-auto shrink-0 -translate-x-8 md:h-123.5 md:-translate-x-20"
          />
        </div>
      </div>
    </div>
  </section>
);
